const MAX_SEARCH_TERMS = 8;

export interface MatchSegment {
    text: string;
    match: boolean;
}

/** Split a query into the terms the server searches for, by the same rules as its `split_search_terms`. */
export function searchTerms(q: string): string[] {
    const visible = q
        .replace(/[\t\n\v\f\r]/g, " ")
        .replace(/[\p{Cc}\uFEFF]/gu, "");
    const terms: string[] = [];
    const seen = new Set<string>();
    for (const term of visible.trim().split(/\s+/)) {
        const key = term.toLowerCase();
        if (term && !seen.has(key)) {
            seen.add(key);
            terms.push(term);
        }
    }
    return terms.slice(0, MAX_SEARCH_TERMS);
}

/** Split text into matched and unmatched runs, taking the longest term that starts at each index. */
export function splitMatches(text: string, terms: string[]): MatchSegment[] {
    const needles = terms
        .filter(Boolean)
        .map((term) => ({ length: term.length, lower: term.toLowerCase() }))
        .sort((a, b) => b.length - a.length);
    if (needles.length === 0) return [{ text, match: false }];

    const segments: MatchSegment[] = [];
    let plainStart = 0;
    let index = 0;
    while (index < text.length) {
        const needle = needles.find(
            ({ length, lower }) =>
                text.slice(index, index + length).toLowerCase() === lower
        );
        if (!needle) {
            index += 1;
            continue;
        }
        if (plainStart < index) {
            segments.push({
                text: text.slice(plainStart, index),
                match: false,
            });
        }
        segments.push({
            text: text.slice(index, index + needle.length),
            match: true,
        });
        index += needle.length;
        plainStart = index;
    }
    if (plainStart < text.length) {
        segments.push({ text: text.slice(plainStart), match: false });
    }
    return segments;
}
